import 'twin.macro'

import Button from 'components/UI/Buttons/Button'
import { Modal } from 'components/UI/Modal'
import { useAppSelector } from 'hooks'
import { useDeviceInfo } from 'hooks/useDeviceInfo'
import { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isLoggedInSelector } from 'redux/store/slices/authSlice'
import { getCurrentStepNumberSelector } from 'redux/store/slices/statusSlice'
import tw from 'twin.macro'

import AuthContent from '../Auth'
import LoanConditionLine from '../LoanConditionLine'
import ProfileMenu from '../ProfileMenu'
import DesktopHeader from './DesktopHeader'
import MobileHeader from './MobileHeader'

const Header = () => {
  // Tools
  const { t } = useTranslation('main')

  // Selectors
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const { step: currentStep } = useAppSelector(getCurrentStepNumberSelector)

  // State
  const [open, setOpen] = useState(false)

  // Contexts
  const { isDesktop } = useDeviceInfo()

  // Handlers
  const onClose = () => {
    setOpen(false)
  }

  return (
    <Fragment>
      <header tw='bg-secondary'>
        <div tw='flex items-center mx-auto py-3 px-4 justify-between space-x-3 md:space-x-10 md:py-6 md:px-6 max-w-layout'>
          {!isDesktop ? <MobileHeader /> : <DesktopHeader />}
          {!isLoggedIn ? (
            <Button variant='link' twStyle={tw`text-xs font-normal`} onClick={() => setOpen(true)}>
              {t('login', { ns: 'common' })}
            </Button>
          ) : (
            <ProfileMenu />
          )}
        </div>
      </header>
      {currentStep === 4 && <LoanConditionLine />}
      <Modal
        title={t('flow-enter-cabinet')}
        open={open}
        onClose={onClose}
        wrapperStyle={tw`overflow-hidden`}
        twStyle={tw`md:w-[460px] p-6`}
        withBackdrop={false}
      >
        <AuthContent onCloseModal={onClose} />
      </Modal>
    </Fragment>
  )
}

export default Header
